// HTTP 下 crypto.subtle 不可用，但 crypto.getRandomValues 仍可提供安全随机数。
// 使用现有依赖中的 AES-256-GCM 实现，保留认证标签，不使用明文或自制加密。
import { createCipheriv, createDecipheriv } from 'browserify-aes/browser';
import { Buffer } from 'buffer/';

export function encryptDraft(plain, key, iv) {
  const cipher = createCipheriv('aes-256-gcm', Buffer.from(key), Buffer.from(iv));
  const encrypted = Buffer.concat([cipher.update(plain, 'utf8'), cipher.final(), cipher.getAuthTag()]);
  return new Uint8Array(encrypted).buffer;
}

export function decryptDraft(record) {
  const encrypted = Buffer.from(record.data);
  if (encrypted.length < 16) throw new Error('草稿密文不完整');
  const cipher = createDecipheriv('aes-256-gcm', Buffer.from(record.key), Buffer.from(record.iv));
  cipher.setAuthTag(encrypted.slice(-16));
  const plain = Buffer.concat([cipher.update(encrypted.slice(0, -16)), cipher.final()]);
  return JSON.parse(plain.toString('utf8'));
}
